import { get } from 'lodash';
import { connect } from 'react-redux';
import { refetchPatients } from '../redux/queryReducer';

const mapDispatchToProps = (dispatch, { refetchPatientsCount }) => ({
  onRefetchPatients() {
    dispatch(refetchPatients({ refetchPatientsCount: refetchPatientsCount + 1 }));
  },
});

const mapStateToProps = state => ({
  // We use the count as an ID for the query and increasing it will refetch the query
  refetchPatientsCount: get(state, 'query.patients.refetchPatientsCount'),
});

export default Component =>
  connect(mapStateToProps)(connect(null, mapDispatchToProps)(Component));
